module.exports = __webpack_public_path__ + "static/img/bg-3.79d1af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-3.png
// module id = dppK
// module chunks = 0